import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: enrolments.ENROLLearner.
export default class EnrolLearner extends Fragment {
  declare [Type]: 'enrolments/nz-moe/enrol-learner';

  @attr('string', { defaultValue: '' })
  declare nsn: string;

  @attr('boolean', { defaultValue: false })
  declare isConfidential: boolean;

  @attr('string', { defaultValue: '' })
  declare enrolURI: string;

  @attr('string')
  declare birthdate: string | undefined;

  @attr('string', { defaultValue: '' })
  declare firstName: string;

  @attr('string', { defaultValue: '' })
  declare lastName: string;

  @attr('string', { defaultValue: '' })
  declare gender: string;

  @attr('string')
  declare startDate: string | undefined;

  @attr('string')
  declare lastAttendanceDate: string | undefined;

  @attr('string', { defaultValue: '' })
  declare schoolName: string;
}
